import React from 'react';
import './TituloCentrado.css'

const TituloCentrado = (props) => {
  return (
      <div className="col-sm-12 text-center titulo-padding-bottom">
        <h2 className> {props.titulo}</h2>
      </div>
  )
}

export default TituloCentrado


// WEBPACK FOOTER //
// ./src/layout/TituloCentrado.js